import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from "react";
import "../Reset.css";
import "./Start.css";
export const StartView = (props) => {
    const [submitDisabled, setSubmitDisabled] = useState(false);
    const TryStart = () => {
        if (submitDisabled)
            return;
        setSubmitDisabled(true);
        props.Start();
    };
    return (_jsx(_Fragment, { children: _jsx("div", Object.assign({ id: "startContainer" }, { children: _jsx("div", Object.assign({ id: "startRatio" }, { children: _jsxs("div", Object.assign({ id: "startDiv" }, { children: [_jsx("button", { id: "startButton", "aria-label": "Start", tabIndex: 0, onClick: () => TryStart() }), _jsx("img", { id: "startButtonBackground", alt: "startButtonImage" }), _jsx("img", { id: "startButtonHighlight", alt: "startButtonHoverImage" }), _jsx("img", { id: "startButtonImage", alt: "startButtonImage" })] })) })) })) }));
};
